// Stimulus controller manifest (trimmed to coach scope for roofguide-ai).
// Run ./bin/rails stimulus:manifest:update to regenerate, but note this app
// was trimmed by hand to the coach controller set.

import { application } from "./application"

// Surviving generic UI controllers restored from the source app.
import DropdownController from "./dropdown_controller"
import DismissableController from "./dismissable_controller"
import ClipboardController from "./clipboard_controller"
import QuizWidgetController from "./quiz_widget_controller"

// Coach controllers (created by PB-2; currently stubs).
import ChatController from "./chat_controller"
import ChatUploadController from "./chat_upload_controller"
import FeedbackController from "./feedback_controller"
import TodoController from "./todo_controller"
import TodoFormController from "./todo_form_controller"
import MeetingActionsController from "./meeting_actions_controller"
import MeetingFormController from "./meeting_form_controller"
import ScriptController from "./script_controller"
import SettlementFormController from "./settlement_form_controller"
import BulkUploadController from "./bulk_upload_controller"
import PanelTabsController from "./panel_tabs_controller"
import AnalysisProgressController from "./analysis_progress_controller"

application.register("dropdown", DropdownController)
application.register("dismissable", DismissableController)
application.register("clipboard", ClipboardController)
application.register("quiz-widget", QuizWidgetController)

application.register("chat", ChatController)
application.register("chat-upload", ChatUploadController)
application.register("feedback", FeedbackController)
application.register("todo", TodoController)
application.register("todo-form", TodoFormController)
application.register("meeting-actions", MeetingActionsController)
application.register("meeting-form", MeetingFormController)
application.register("script", ScriptController)
application.register("settlement-form", SettlementFormController)
application.register("bulk-upload", BulkUploadController)
application.register("panel-tabs", PanelTabsController)
application.register("analysis-progress", AnalysisProgressController)

import DocumentExplorerController from "./document_explorer_controller"
application.register("document-explorer", DocumentExplorerController)

import DocumentGalleryController from "./document_gallery_controller"
application.register("document-gallery", DocumentGalleryController)
